/**
 * Triggers a browser download for a remote (presigned S3) URL.
 *
 * The URL is expected to be a freshly signed, short-lived link served with a
 * `Content-Disposition: attachment` header, so the original filename comes from
 * the response — not from the `download` attribute (which browsers ignore for
 * cross-origin links). We must not revoke the URL here: it is a remote https URL,
 * not a `blob:` object URL.
 *
 * We open via `target="_blank"` so that if the URL is ever served without an
 * `attachment` disposition the browser opens it in a new tab instead of
 * navigating away from the SPA.
 */
export const triggerFileDownload = (url: string, fileName?: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName ?? '';
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
